export default __webpack_public_path__ + "static/media/BENGUIAT.4f0eb91c.TTF";